import { fbFunctions } from "../../../config/firebase";

const fb = require('../../../config/firebase.js')

import axios from 'axios'
import {i18n} from "../../../i18n";

const state = () => ({
    user: {},
    userId: '',
    userLoaded: false,
    visiterIsBlocked: false,
})

const getters = {}

const actions = {
    fetchUserProfile({ commit, state }, payload) {
        const vm = this;
        fb.usersCollection
            .doc(payload.visitedUserId)
            .collection("user_blocked_users")
            .doc(payload.visitedUserId)
            .get()
            .then(function(doc) {
                if(doc.exists) commit('setBlockStatus', true);
                else commit('setBlockStatus', false);
            })
            .catch(function(error) {
                console.log("Error getting document:", error);
            });
        fb.usersCollection
            .doc(payload.visitedUserId)
            .get()
            .then(function(doc) {
                if (doc.exists) {
                    commit('setUserData', doc.data());
                    // if(doc.data().blocked_users.includes(payload.visiterUserId)) commit('setBlockStatus', true);
                    // else commit('setBlockStatus', false);
                }
                if(payload.visiterUserId !== state.user.id) vm.dispatch('profile/writeProfileVisit');
                commit('setUserLoaded', true);
            })
            .catch(function(error) {
                console.log("Error getting document:", error);
            });
    },
    writeProfileVisit({ commit, state }) {
        let writeProfileVisitCall = fbFunctions.httpsCallable('api');
        writeProfileVisitCall({
            type: 'createFeed',
            parameters: {
                'profileOwnerName': state.user.nickname,
                'profileOwnerId': state.user.id,
                'profileOwnerAvatar': state.user.avatar,
                'type': 'VISIT_URL'
            }
        })
    },
    fetchUserProfileAnonymous({ commit, state }, payload) {
        const userId = payload.visitedUserId;
        let url;
        if (location.hostname !== "localhost")
            url = "https://europe-west3-socialdiese.cloudfunctions.net/apiUnAuth?name=retrieveUserProfile&parameters[userId]="+userId;
        else
            url = "http://localhost:5001/socialdiese/europe-west3/apiUnAuth?name=retrieveUserProfile&parameters[userId]="+userId;
        axios.get(url)
        .then((response) => {
            commit('setUserData', response.data);
            commit('setUserLoaded', true);
        })
        .catch((e) => console.log("error"));
    },
    fetchUserProfileFromTag({ commit, state }, payload) {
        const tagId = payload.tagId;
        let url;
        if (location.hostname !== "localhost")
            url = "https://europe-west3-socialdiese.cloudfunctions.net/apiUnAuth?name=retrieveOwnerFromTag&parameters[tagId]="+tagId;
        else
            url = "http://localhost:5001/socialdiese/europe-west3/apiUnAuth?name=retrieveOwnerFromTag&parameters[tagId]="+tagId;
        axios.get(url)
            .then((response) => {
                commit('setUserData', response.data);
                commit('setUserLoaded', true);
            })
            .catch((e) => console.log("error"));
    },
    fetchUserEmail({ commit, state }, payload) {
        let saveProfileInfos = fbFunctions.httpsCallable('api');
        Swal.fire(
            i18n.t("profile.modal_fetch_in_progress_title"),
            i18n.t("profile.modal_fetch_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'retrieveUserEmail',
            parameters: {
                'userId': payload.userId,
            }
        })
        .then(function(result) {
            if(result.data.code === "SUCCESS_USER_ACCEPTED_TO_SHOW_EMAIL") {
                swal.fire(
                    i18n.t("profile.modal_fetch_email_success_title"),
                    i18n.t("profile.modal_fetch_email_success_content", {'email': result.data.email }),
                    "success"
                );
            }
            else if(result.data.code === "SUCCESS_USER_DONT_WANT_TO_SHOW_EMAIL") {
                swal.fire(
                    i18n.t("profile.modal_fetch_email_user_dont_show_title"),
                    i18n.t("profile.modal_fetch_email_user_dont_show_content"),
                    "error"
                );
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    "error"
                )
            }
        })
        .catch((e) => {
            console.log(e);
            swal.fire(
                i18n.t("administration.admin.global.modal_generic_error_title"),
                i18n.t("administration.admin.global.modal_generic_error_title"),
                "error"
            )
        });
    },
    writeNetworkClick({commit, state}, payload) {
        let writeNetworkClick = fbFunctions.httpsCallable('api');
        writeNetworkClick({
            type: 'writeNetworkClick',
            parameters: {
                'fieldName': payload.network,
                'userId': state.user.id,
            }
        })
    },
    writeNetworkClickPublic({commit, state}, payload) {
        let url;
        if (location.hostname !== "localhost")
            url = "https://europe-west3-socialdiese.cloudfunctions.net/apiUnAuth?name=writeNetworkClick&parameters[userId]="+state.user.id+"&[fieldName]="+payload.networkField;
        else
            url = "http://localhost:5001/socialdiese/europe-west3/apiUnAuth";
        axios.post(url, {
            'name': 'writeNetworkClick',
            'parameters': {
                'userId': state.user.id,
                'fieldName': payload.networkField
            }
        })
        .then((response) => {})
        .catch((e) => console.log("error"));
    }
}

const mutations = {
    setUserData(state, val) {
        state.user = val;
    },
    setUserLoaded(state, val) {
        state.userLoaded = val;
    },
    setBlockStatus(state, val) {
        state.visiterIsBlocked = val;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/pages/profile.js